import { SumoLogicRUMBrowserSubscriber, SumoLogicLogSubscriber } from "@artis/logger/subscribers";
import { initialize } from "@sumologic/opentelemetry-rum";
import SumoLogger from "sumo-logger";

import type { InitOptions, AuthenticationDetails } from "./types";
import { addLogSubscriber } from "../logger";

// Telemetry uploads that RUM would otherwise trace as app requests (about a third of RUM span
// volume). The SDK matches each string as a substring of the request URL.
export const RUM_IGNORE_URLS = ["browser-intake-datadoghq.eu", "/sumologic/logs"];

export type SumoClient = ReturnType<typeof initialize>;
let sumoLogicRum: SumoClient | undefined;

export const getSumoLogicRum = (): SumoClient | undefined => sumoLogicRum;

export const sumologicAttachAuth = (details: AuthenticationDetails) => {
  if (!sumoLogicRum) return;
  sumoLogicRum.setDefaultAttribute("user.id", details.user.id);
  sumoLogicRum.setDefaultAttribute("user.username", `${details.user.given_name} ${details.user.family_name}`);
  sumoLogicRum.setDefaultAttribute("user.email", details.user.email);
  sumoLogicRum.setDefaultAttribute("user.hasuraOrgId", details.org.id);
  sumoLogicRum.setDefaultAttribute("user.auth0OrgId", details.org.id);
};

export const sumologicInit = (p: InitOptions) => {
  if (typeof window === "undefined") return;
  sumoLogicRum = initialize({
    collectionSourceUrl: `${window.location.origin}/sumologic/rum`,
    serviceName: "webapp",
    applicationName: "artis-webapp",
    deploymentEnvironment: p.env,
    defaultAttributes: {
      version: p.version,
    },
    ignoreUrls: RUM_IGNORE_URLS,
  });
  addLogSubscriber(new SumoLogicRUMBrowserSubscriber({ rum: sumoLogicRum }));

  const sumoLogger = new SumoLogger({
    endpoint: `${window.location.origin}/sumologic/logs`,
    sendErrors: true,
    sourceName: "webapp",
    sourceCategory: "webapp",
    hostName: window.location.hostname,
    interval: 30_000,
    batchSize: 100_000,
  });
  addLogSubscriber(new SumoLogicLogSubscriber({ logger: sumoLogger }));

  // Batched uploads lose up to one interval of tail on tab close; flush when the page goes away or hides.
  window.addEventListener("pagehide", () => sumoLogger.flushLogs());
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") sumoLogger.flushLogs();
  });
};
